import jwtDecode from 'jwt-decode';
import {
  LOGIN_USER,
  REFRESHING_TOKEN,
  DONE_REFRESHING_TOKEN,
  RESET_TOKEN_VALIDITY,
  GDPR_ACKNOWLEDGED,
  GDPR_OPEN_STEP2,
  REMOVE_HTTP_REQUEST,
  SET_VIRGIL,
  UNSET_VIRGIL,
  STORE_RELOADED,
  AUTH_REMOVE_BLOCK_PROPERTIES,
  AuthState,
  AuthActionTypes,
  IS_FETCHING,
  RESET_IS_FETCHING,
  IS_LOGOUT,
  TEMPORARY_LOGIN_USER,
} from './types/Auth.d';
import {
  IS_VERIFY_WALL_FETCHING,
  RESET_CHANGE_EMAIL_FETCHING,
  RESET_OTP_STATE,
  RESET_VERIFY_WALL_FETCHING,
  SAVE_CHANGE_EMAIL_VERIFY_DATA,
  SAVE_EMAIL_VERIFY_DATA,
  SET_CHANGE_EMAIL_FETCHING,
  SET_EMAIL_VERIFY_WALL_DATA,
  SET_FACELIVENESS_VERIFY_LOADER,
  SET_OTP_STATE,
  START_SELFIE_VERIFICATION,
} from '../actions/actionType';
import { STORE_JOIN_PREDATA, CLEAR_JOIN_PREDATA } from './types/Join.d';

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const initialState: AuthState = {
  isAuthenticated: false,
  jwToken: '',
  gdpr_acknowledged: null,
  gdpr_Step2: false,
  jwtUnixExpiration: '',
  freshTokenPromise: null,
  resetTokenValidity: true,
  webTimestamp: '',
  requestList: [{ loc: null, time: 0 }],
  virgil: false,
  isRecentlyReloaded: false,
  password_disabled: false,
  tokenRefreshing: false,
  isFetching: false,
  isLogout: false,
  isOtpSent: false,
  isChangeEmailFetching: false,
  changeEmailVerifyData: null,
  facelivenessVerifyLoader: false,
  startSelfieVerification: false,
};

const auth = (state = initialState, action: AuthActionTypes): any => {
  //let {data} = action.payload;
  switch (action.type) {
    case LOGIN_USER: {
      const { token, gdpr_acknowledged, password_disabled } = action.payload;
      // parse jwt for expiration timeStamp
      const jwtUnixExpiration = jwtDecode(token).exp;

      // save everything.
      return {
        ...state,
        isAuthenticated: true,
        jwToken: token,
        jwtUnixExpiration,
        gdpr_acknowledged,
        password_disabled,
      };
    }
    // these next cases are for making sure we dont attempt to refresh mutliple JWT's.
    case REFRESHING_TOKEN:
      return {
        ...state,
        freshTokenPromise: action.payload,
        tokenRefreshing: true,
      };
    case DONE_REFRESHING_TOKEN:
      return {
        ...state,
        freshTokenPromise: null,
        tokenRefreshing: false,
      };
    case RESET_TOKEN_VALIDITY:
      return {
        ...state,
        resetTokenValidity: action.payload,
      };
    case GDPR_ACKNOWLEDGED:
      return {
        ...state,
        gdpr_Step2: false,
        gdpr_acknowledged: true,
      };
    case GDPR_OPEN_STEP2:
      return {
        ...state,
        gdpr_Step2: true,
      };
    case REMOVE_HTTP_REQUEST:
      return {
        ...state,
        requestList: state.requestList.filter(function (a) {
          return a.loc !== action.payload;
        }),
      };
    case SET_VIRGIL:
      return {
        ...state,
        virgil: true,
      };
    case UNSET_VIRGIL:
      return {
        ...state,
        virgil: true,
      };
    case STORE_RELOADED:
      return {
        ...state,
        isRecentlyReloaded: Date.now(),
      };
    case AUTH_REMOVE_BLOCK_PROPERTIES:
      return {
        ...state,
        password_disabled: false,
      };
    case IS_FETCHING:
      return {
        ...state,
        isFetching: !state.isFetching,
      };
    case RESET_IS_FETCHING:
      return {
        ...state,
        isFetching: false,
      };
    case IS_LOGOUT:
      return {
        ...state,
        isLogout: action.payload,
      };
    case SAVE_EMAIL_VERIFY_DATA:
      return {
        ...state,
        emailVerifyData: action.payload,
      };
    case SET_OTP_STATE:
      return {
        ...state,
        isOtpSent: true,
      };
    case RESET_OTP_STATE:
      return {
        ...state,
        isOtpSent: false,
      };
    case TEMPORARY_LOGIN_USER: {
      const { token, gdpr_acknowledged, password_disabled } = action.payload;
      // parse jwt for expiration timeStamp
      const jwtUnixExpiration = token ? jwtDecode(token).exp : '';

      // save everything.
      return {
        ...state,
        isAuthenticated: false,
        jwToken: token,
        jwtUnixExpiration,
        gdpr_acknowledged,
        password_disabled,
      };
    }
    case SET_EMAIL_VERIFY_WALL_DATA:
      return {
        ...state,
        emailVerifyWallData: action.payload,
      };
    case IS_VERIFY_WALL_FETCHING:
      return {
        ...state,
        isVerifyEmailFetching: !state.isVerifyEmailFetching,
      };
    case RESET_VERIFY_WALL_FETCHING:
      return {
        ...state,
        isVerifyEmailFetching: false,
      };
    case SAVE_CHANGE_EMAIL_VERIFY_DATA:
      return {
        ...state,
        changeEmailVerifyData: action.payload,
      };
    case SET_CHANGE_EMAIL_FETCHING:
      return {
        ...state,
        isChangeEmailFetching: !state.isChangeEmailFetching,
      };
    case RESET_CHANGE_EMAIL_FETCHING:
      return {
        ...state,
        isChangeEmailFetching: false,
      };
    case STORE_JOIN_PREDATA:
      return {
        ...state,
        joinPredata: action.payload,
      };
    case CLEAR_JOIN_PREDATA:
      return {
        ...state,
        joinPredata: {},
      };
    case SET_FACELIVENESS_VERIFY_LOADER:
      return {
        ...state,
        facelivenessVerifyLoader: action.payload,
      };
    case START_SELFIE_VERIFICATION:
      return {
        ...state,
        startSelfieVerification: action.payload,
      };
    default:
      return state;
  }
};

export default auth;
